import { render } from "./ConfirmationComponent.vue?vue&type=template&id=f4ab0658&ts=true"
import script from "./ConfirmationComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmationComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src569833660/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__